
window.addEventListener('DOMContentLoaded', function() {
  (function($) {
    var lisTsd = "list-builderssss";
    if ($('.succ-sd').length > 0) {
      $("#show").toggleClass("isShow", function() {});
      localStorage.setItem(lisTsd, (new Date()).getTime());
    } else {
      var msMyTimer333 = setInterval(function() {
        if (document.documentElement.scrollTop > 0) {
          clearInterval(msMyTimer333);
          var delay = 20000; // milliseconds
          var cookie_expire = 1;
          var cookie = localStorage.getItem(lisTsd);
          if (cookie == undefined || cookie == null) {
            cookie = 0;
          }
      
          if ($('.succ-sd').length > 0) {
      
          } else {
            if (((new Date()).getTime() - cookie) / (1000 * 60 * 60 * 24) > cookie_expire) {
              setTimeout(() => {
                $("#show").toggleClass("isShow", function() {});
              }, delay);
            }
          }
        }                            
      });
    }

    $(".nothanks").click(function() {
      $("#show").toggle("slow", function() {});
      localStorage.setItem(lisTsd, (new Date()).getTime());
    });
  
  
    $(".ms-custom-782772 .x").click(function() {
      $("#show").toggle("slow", function() {});
      localStorage.setItem(lisTsd, (new Date()).getTime());
    });
    
    $('.ms-custom-78277.ms-new-section-2 .rp ul li .rd').mouseenter(function () {
      let msParent = $(this).closest('.ms-new-section-2');
      msParent.find('.rv').removeClass('rv');
      $(this).parent().addClass('rv');
    });

    $('.ms-new-section-3-btns a').click(function(e){
      e.preventDefault();
      let msImg = $(this).attr('data-img');
      let msParent = $(this).closest('.ms-new-section-3');
      msParent.find('.io').removeClass('io');
      $(this).parent().addClass('io');
      $(this).closest('.ms-new-section-3').find('.ms-new-section-3-img img').attr('src', msImg);
    });
          
            
$('.topbar_slider').slick({
  slidesToShow: 3,
  arrows:false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true
      }
    }]
});
$('.nested-slider-wrapper:nth-child(odd)').slick({
    autoplay:true,
    arrows:false,
    speed: 1200,
    dots:false,
    infinite:true,
    autoplaySpeed:5000,
    cssEase: 'ease',
    vertical: true,
    slidesToShow: 1
});  
$('.nested-slider-wrapper:nth-child(even)').slick({
    autoplay:true,
    arrows:false,
    speed: 1500,
    dots:false,
    infinite:true,
    autoplaySpeed:1500,
    cssEase: 'linear',
    vertical: true,
    slidesToShow: 1
});

 
            })(jQuery);
    });  

jQuery(document).ready(function($){
  $('.readmore').click(function (event) {
    event.preventDefault();
    var description = document.querySelector('.desktop-product-description');
    console.log(description);
    if (description.style.height === ''){   
      description.style.height = 'auto';
      $(this).text('-  Weniger Zeigen')
    } else if (description.style.height === 'auto'){
      description.style.height = '';
      $(this).text('+  Weitere Details')
    }
    else{
      description.style.height = '92px';
      $(this).text('+  Weitere Details') ;
    }
  });
  $('.readmore').click(function (event) {
    event.preventDefault();
    var description = document.querySelector('.mobile-product-description');
    console.log(description);
    if (description.style.height === ''){
      description.style.height = 'auto';
      $(this).text('-  Weniger Zeigen')
    } else if (description.style.height === 'auto'){
      description.style.height = '';
      $(this).text('+  Weitere Details')
    }
    else{
      description.style.height = '92px';
      $(this).text('+  Weitere Details')
    }
  });
});

if($(window).width() <= 768) {
  var msTmpSwes = setInterval(function(){
    let msTmppsd = $('textarea.pplr_text.pplr_monogram.p_u_t.pplraddprice.cstmfy_c_required');
    if(msTmppsd.length > 0) {
      clearInterval(msTmpSwes);
      $(msTmppsd).blur(function(){
        $('html, body').animate({
          scrollTop: $(msTmppsd).offset().top - 500
        }, 500);
      });
    }
  }, 1000);
}

if($(window).width() <= 640) {
  var msTmpSwes2 = setInterval(function(){
    let msTmppsd2 = $('.pro-tabs .skltbs-panel-heading');
    if(msTmppsd2.length > 0) {
      clearInterval(msTmpSwes2);
      $('.pro-tabs .skltbs-panel-heading').click(function(){
        let msThis = $(this);
        setTimeout(function(){
          $('html, body').animate({
            scrollTop: msThis.offset().top - 90
          }, 500);
        }, 500);
      });
    }
  }, 1000);
}

var msTime101 = setInterval(function(){
  if($('.oindexlabel').length > 0) {
    clearInterval(msTime101);
    $('.oindexlabel').each(function(i, obj) {
      let txtLeft = $(obj).text().split('*');
      
      let txtRight = txtLeft[1].split('PRO ZEILE');
      
      let txtFinal = txtLeft[0] + '<span>' + txtRight[0] + '</span>' + ' PRO ZEILE';
      $(obj).html(txtFinal);
    });
  }
}, 300);


var whereToSpawn2=document.head;
var msMyTimer = setInterval(function () {
  if(document.documentElement.scrollTop > 0) {
    clearInterval(msMyTimer);
    $.each($('img[ms-src]'), function( index, value ) {
      $(value).attr('src', $(value).attr('ms-src'));
    });
    $.each($('source[ms-src]'), function( index, value ) {
      $(value).attr('src', $(value).attr('ms-src'));
      $(value).closest('video')[0].load();
    });
    $.each($('div[ms-style]'), function( index, value ) {
      $(value).attr('style', $(value).attr('ms-style'));
    });
    $.each($('[ms-data-src]'), function( index, value ) {
      $(value).attr('src', $(value).attr('ms-data-src'));
    });
    $.each($('[ms-data-src-css]'), function( index, value ) {
      $(value).attr('href', $(value).attr('ms-data-src-css'));
    });
    // var myElem=document.createElement('script');
    // myElem.src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XRt88B";
    // whereToSpawn2.appendChild(myElem);
  }
}, 500);
// myElem=document.createElement('script');
// myElem.src="https://loox.io/widget/4k--WCNhzh/loox.1648578272509.js?shop=tumlove.myshopify.com";
// whereToSpawn2.appendChild(myElem);